var map = {
	"./1.png": "0ca1",
	"./2.png": "b9af",
	"./3.png": "c2e4",
	"./4.png": "1105",
	"./5.png": "9310",
	"./6.png": "2175",
	"./barra.jpeg": "7f86",
	"./caratula.jpg": "e023",
	"./caratula_2027.png": "b37c",
	"./cintillo.png": "9069",
	"./cintillo_2027.png": "aa5e",
	"./custom-styles.css": "30de",
	"./default-image.png": "5516",
	"./file.jpg": "3bd8",
	"./imagen.jpg": "1874",
	"./loader.gif": "fa5e",
	"./logo-opb-veda.png": "f023",
	"./logo-v.png": "d22c",
	"./logo-v_2027.png": "2828",
	"./logo.png": "cf05",
	"./logo_2027.png": "f6f1",
	"./pdf.jpg": "03d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";